import Http from "@/api/http.js"

export default {
  index(params) {
    return Http.get("/shipping_rates", { params })
  },

  show(id) {
    return Http.get(`/shipping_rates/${id}`)
  },

  create(shipping_rate) {
    return Http.post("/shipping_rates", { shipping_rate })
  },

  update(shipping_rate) {
    return Http.put(`/shipping_rates/${shipping_rate.id}`, { shipping_rate })
  },

  delete(id) {
    return Http.delete(`/shipping_rates/${id}`)
  },
}
